<template>
  <div class="recharge-wrap">
    <div class="recharge-card">
      <!-- 头部 -->
      <div class="card-header">
        <div class="card-title">账户充值缴费</div>
        <div class="card-desc">
          充值额度用于接口核验调用，充值后额度实时到账
        </div>
      </div>

      <div class="card-body">
        <!-- 金额选择区域 -->
        <div class="form-section">
          <div class="section-title">
            充值金额 <span class="req">*</span>
          </div>
          <div class="amount-list">
            <div
              v-for="item in amountOptions"
              :key="item.value"
              class="amount-item"
              :class="{ active: selectAmount === item.value }"
              @click="
                selectAmount = item.value;
                customMoney = '';
              "
            >
              ¥{{ item.value }}
            </div>
            <div
              class="amount-item custom-tag"
              :class="{ active: selectAmount === 'custom' }"
              @click="selectAmount = 'custom'"
            >
              自定义金额
            </div>
          </div>

          <!-- 自定义金额输入框 -->
          <div class="custom-input-box" v-if="selectAmount === 'custom'">
            <div class="input-wrap">
              <span class="prefix">¥</span>
              <el-input
                v-model="customMoney"
                type="number"
                placeholder="最低充值1000元，请输入整数金额"
                @keyup.enter="submitRecharge"
              />
            </div>
            <div class="tip-text">
              充值金额不能小于1000元，且为整数
            </div>
          </div>
          <div class="error-text" v-if="errorMsg.amount">
            {{ errorMsg.amount }}
          </div>
        </div>

        <!-- 支付方式 -->
        <div class="form-section">
          <div class="section-title">
            支付方式 <span class="req">*</span>
          </div>
          <div class="pay-list">
            <div
              v-for="pay in payTypeList"
              :key="pay.value"
              class="pay-item"
              :class="{ active: payType == pay.value }"
              @click="payType = pay.value"
            >
              <div class="pay-icon">
                <svg
                  v-if="pay.value === 'WECHAT_PAY'"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="#07C160"
                >
                  <path
                    d="M8.75 12.999c0 .69-.557 1.249-1.25 1.249s-1.25-.559-1.25-1.249c0-.69.557-1.249 1.25-1.249s1.25.559 1.25 1.249zm4.75 0c0 .69-.557 1.249-1.25 1.249s-1.25-.559-1.25-1.249c0-.69.557-1.249 1.25-1.249s1.25.559 1.25 1.249zm-6-5c0 .69-.557 1.249-1.25 1.249s-1.25-.559-1.25-1.249c0-.69.557-1.249 1.25-1.249s1.25.559 1.25 1.249zm2.5 0c0 .69-.557 1.249-1.25 1.249s-1.25-.559-1.25-1.249c0-.69.557-1.249 1.25-1.249s1.25.559 1.25 1.249zm10 4c0-3.313-3.134-6-7-6s-7 2.687-7 6 3.134 6 7 6c.767 0 1.498-.113 2.164-.317.184-.056.387-.022.543.09l1.462 1.024a.5.5 0 00.78-.41l-.304-1.538a.498.498 0 01.178-.473c.825-.634 1.377-1.467 1.604-2.412.135-.564.213-1.148.213-1.744z"
                  />
                </svg>
                <svg
                  v-if="pay.value === 'ALIPAY'"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="#1677FF"
                >
                  <path
                    d="M21.422 15.358c-3.333-1.533-5.555-2.444-6.666-2.733.666-1.111 1.111-2.444 1.333-3.888h-3.111V7.47h3.777V5.247h-3.777V3.024h-2.222v2.223H7.001v2.223h3.778v1.267H7.668v2.222h5.333c-.222.666-.444 1.333-.777 1.888-2.444.777-5.111 1.777-7.777 3.111 1.333 1.555 3.333 2.444 5.555 2.444 2.222 0 4.222-.889 5.555-2.444.889.444 1.777.889 2.666 1.333 1.333-1.111 2.222-2.666 2.666-4.444z"
                  />
                </svg>
                <svg
                  v-if="pay.value === 'CORPORATE_TRANSFER'"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="#2B5BFF"
                >
                  <path
                    d="M3 10h18M7 15h1m4 0h1m-7 4h12a3 3 0 003-3V8a3 3 0 00-3-3H6a3 3 0 00-3 3v8a3 3 0 003 3z"
                    stroke="currentColor"
                    stroke-width="2"
                    stroke-linecap="round"
                  />
                </svg>
              </div>
              <div class="pay-name">{{ pay.label }}</div>
            </div>
          </div>
          <div class="error-text" v-if="errorMsg.pay">
            {{ errorMsg.pay }}
          </div>
        </div>

        <!-- 对公转账信息面板 -->
        <div class="transfer-panel" v-if="payType == 'CORPORATE_TRANSFER'">
          <div class="panel-title">对公转账信息</div>
          <div class="transfer-row">
            <span class="label">收款单位：</span>
            <span class="value">爱求索信息技术吉林有限公司</span>
          </div>
          <div class="transfer-row">
            <span class="label">开户银行：</span>
            <span class="value">中国建设银行股份有限公司长春高新技术产业开发区支行</span>
          </div>
          <div class="transfer-row">
            <span class="label">银行账号：</span>
            <span class="value">2205 0137 0100 0000 3534</span>
          </div>
          <div class="transfer-tip">
            ⚠️
            转账请务必备注：【企业名称+缴存金额】，转账完成后联系客服人工核实入账
          </div>
        </div>

        <!-- 温馨提示 -->
        <div class="notice-block">
          <span class="dot"></span>
          <span>充值额度长期有效，不设有效期；充值款项一经到账，不予退款。</span>
        </div>
      </div>

      <!-- 底部操作按钮 -->
      <div class="card-footer">
        <el-button
          size="large"
          class="btn-primary"
          :loading="submitLoading"
          @click="submitRecharge"
        >
          立即去支付
        </el-button>
      </div>
    </div>

    <!-- ==========【缺失的支付弹窗】新增 ========== -->
    <el-dialog
      v-model="payDialogVisible"
      title="扫码支付"
      width="440px"
      :close-on-click-modal="false"
      @opened="handleDialogOpened"
      @close="dialogCloseHandler"
    >
      <div class="pay-dialog-content" style="text-align:center;padding:10px 0;">
        <!-- 微信/支付宝二维码区域 -->
        <div v-if="['WECHAT_PAY','ALIPAY'].includes(payInfo.paytype)">
          <canvas ref="qrCanvas"></canvas>
          <div style="margin-top:16px;font-size:14px;color:#666;">
            <p>订单号：{{ payInfo.orderNo }}</p>
            <p style="margin-top:6px;">
              充值金额：<span style="color:#de1c2c;font-weight:bold;">¥{{ payInfo.amount }}</span>
            </p>
          </div>
          <div style="margin-top:12px;font-size:13px;color:#999;">
            ⚠️ 使用对应APP扫码支付，支付成功页面自动识别
          </div>
          <el-button size="small" @click="refreshQr" style="margin-top:12px;">刷新二维码</el-button>
        </div>

        <!-- 对公转账弹窗展示 -->
        <div v-else>
          <div style="text-align:left;background:#f7f8fa;border-radius:10px;padding:18px;">
            <div style="font-weight:bold;color:#111;margin-bottom:12px;">对公转账信息</div>
            <div class="transfer-row">
              <span class="label">收款单位：</span>
              <span class="value">爱求索信息技术吉林有限公司</span>
            </div>
            <div class="transfer-row">
              <span class="label">开户银行：</span>
              <span class="value">中国建设银行股份有限公司长春高新技术产业开发区支行</span>
            </div>
            <div class="transfer-row">
              <span class="label">银行账号：</span>
              <span class="value">2205 0137 0100 0000 3534</span>
            </div>
            <div style="margin-top:12px;padding-top:12px;border-top:1px solid #eee;">
              <div style="color:#e64340;font-weight:bold;">⚠️转账备注</div>
              <div style="margin-top:4px;">{{ payInfo.orderNo }}</div>
            </div>
          </div>
          <div style="margin-top:16px;font-size:13px;color:#999;">
            转账完成等待财务人工对账，对账成功额度自动到账
          </div>
        </div>
      </div>
      <template #footer>
        <el-button @click="payDialogVisible = false">关闭</el-button>
      </template>
    </el-dialog>
  </div>
</template>

<script setup>
import { ref, reactive, onUnmounted } from "vue";
import { ElMessage } from "element-plus";
import { payPay, rechargeStatus } from "@/api/api";
import QRCode from "qrcode";

// 支付弹窗
const payDialogVisible = ref(false);
const qrCanvas = ref(null);
// 轮询定时器
const pollTimer = ref(null);
// 最大轮询次数，防止无限请求
const MAX_POLL_COUNT = 30;
let pollCount = 0;

// 支付订单信息
const payInfo = reactive({
  orderNo: "",
  amount: 0,
  payUrl: "",
  paytype: "",
});

// 快捷金额选项
const amountOptions = [
  { value: 1000 },
  { value: 3000 },
  { value: 5000 },
  { value: 10000 },
];

// 支付方式
const payTypeList = [
  { label: "微信支付", value: "WECHAT_PAY" },
  { label: "支付宝", value: "ALIPAY" },
  { label: "对公转账", value: "CORPORATE_TRANSFER" },
];

const selectAmount = ref(1000);
const customMoney = ref("");
const payType = ref("");
const submitLoading = ref(false);
const errorMsg = reactive({
  amount: "",
  pay: "",
});

// 表单校验
const validate = () => {
  errorMsg.amount = "";
  errorMsg.pay = "";
  let pass = true;

  let payAmount = 0;
  if (selectAmount.value === "custom") {
    payAmount = Number(customMoney.value);
    if (!customMoney.value || isNaN(payAmount)) {
      errorMsg.amount = "请输入充值金额";
      pass = false;
    } else if (payAmount < 1000) {
      errorMsg.amount = "自定义金额最低1000元";
      pass = false;
    } else if (!Number.isInteger(payAmount)) {
      errorMsg.amount = "充值金额必须为整数";
      pass = false;
    }
  } else {
    payAmount = selectAmount.value;
  }

  if (!payType.value) {
    errorMsg.pay = "请选择支付方式";
    pass = false;
  }
  return pass;
};

// 提交充值创建订单
const submitRecharge = async () => {
  if (!validate()) return;
  submitLoading.value = true;

  try {
    const payAmount =
      selectAmount.value === "custom"
        ? Number(customMoney.value)
        : selectAmount.value;

    const params = {
      amount: payAmount,
      paytype: payType.value,
    };
    const res = await payPay(params);
    if (res.code !== 200) {
      ElMessage.error(res.message || "创建订单失败");
      return;
    }
    const data = res.data;
    // 赋值订单信息
    payInfo.orderNo = data.orderNo;
    payInfo.amount = data.amount;
    payInfo.payUrl = data.pay_url;
    payInfo.paytype = data.paytype;

    // 打开支付弹窗
    payDialogVisible.value = true;
    pollCount = 0;
  } catch (e) {
    ElMessage.error("请求异常，请稍后重试");
    console.error(e);
  } finally {
    submitLoading.value = false;
  }
};

// 弹窗完全打开后执行（DOM渲染完成）
const handleDialogOpened = async () => {
  // 对公转账不需要二维码，不执行绘制
  if (!["WECHAT_PAY", "ALIPAY"].includes(payInfo.paytype)) {
    startPolling();
    return;
  }
  if (!payInfo.payUrl || !qrCanvas.value) return;

  // 绘制二维码
  try {
    await QRCode.toCanvas(qrCanvas.value, payInfo.payUrl, {
      width: 220,
      margin: 2,
    });
  } catch (err) {
    ElMessage.warning("二维码生成失败，请点击刷新");
    console.error("二维码绘制异常：", err);
  }
  startPolling();
};

// 刷新二维码
const refreshQr = async () => {
  if (!payInfo.payUrl || !qrCanvas.value) return;
  try {
    await QRCode.toCanvas(qrCanvas.value, payInfo.payUrl, {
      width: 220,
      margin: 2,
    });
    ElMessage.success("二维码已刷新");
  } catch (err) {
    ElMessage.error("刷新失败");
  }
};

// 开启轮询订单状态
const startPolling = () => {
  // 先清除旧定时器
  if (pollTimer.value) clearInterval(pollTimer.value);
  pollTimer.value = setInterval(async () => {
    pollCount++;
    // 超过最大次数停止轮询
    if (pollCount >= MAX_POLL_COUNT) {
      clearInterval(pollTimer.value);
      pollTimer.value = null;
      ElMessage.warning("查询超时，请重新发起充值");
      return;
    }
    await queryPayStatus();
  }, 5000);
};

// 查询订单支付状态
const queryPayStatus = async () => {
  try {
    const res = await rechargeStatus({
      orderno: payInfo.orderNo,
    });
    if (res.code !== 200) return;
    // 支付成功，关闭弹窗、停止轮询
    if (res.data.status === "SUCCESS") {
      ElMessage.success("充值成功！");
      payDialogVisible.value = false;
    }
  } catch (err) {
    console.error("状态查询异常", err);
  }
};

// 弹窗关闭统一处理
const dialogCloseHandler = () => {
  // 停止轮询，防止后台持续请求
  if (pollTimer.value) {
    clearInterval(pollTimer.value);
    pollTimer.value = null;
  }
  pollCount = 0;
  // 清空订单信息
  payInfo.orderNo = "";
  payInfo.amount = 0;
  payInfo.payUrl = "";
  payInfo.paytype = "";
};

// 组件销毁强制清理定时器，防止内存泄漏
onUnmounted(() => {
  if (pollTimer.value) {
    clearInterval(pollTimer.value);
    pollTimer.value = null;
  }
});
</script>

<style lang="scss" scoped>
.recharge-wrap {
  width: 100%;
  min-height: 100vh;
  padding: 32px 24px;
  font-family: -apple-system, BlinkMacSystemFont, "PingFang SC", "Microsoft YaHei", "Helvetica Neue", Arial, sans-serif;
  background: radial-gradient(1200px 600px at 10% -10%, #e8efff 0%, transparent 60%),
    radial-gradient(900px 500px at 110% 110%, #f0eaff 0%, transparent 55%),
    linear-gradient(180deg, #f7f9ff 0%, #eef2fb 100%);
  display: flex;
  justify-content: center;

  .recharge-card {
    width: 100%;
    max-width: 720px;
    background: #ffffff;
    border-radius: 16px;
    box-shadow: 0 1px 2px rgba(16, 24, 40, 0.04), 0 12px 32px -12px rgba(16, 24, 40, 0.12),
      0 32px 64px -32px rgba(43, 91, 255, 0.18);
    overflow: hidden;
  }

  .card-header {
    padding: 36px 48px 24px;
    border-bottom: 1px solid #eef0f5;
    background: linear-gradient(180deg, #fbfcff 0%, #ffffff 100%);

    .card-title {
      font-size: 22px;
      font-weight: 600;
      color: #111827;
    }

    .card-desc {
      margin-top: 6px;
      font-size: 14px;
      color: #6b7280;
    }
  }

  .card-body {
    padding: 32px 48px;
  }

  .form-section {
    margin-bottom: 32px;

    .section-title {
      display: flex;
      align-items: center;
      gap: 10px;
      font-size: 15px;
      font-weight: 600;
      color: #111827;
      margin-bottom: 18px;

      &::before {
        content: "";
        width: 3px;
        height: 14px;
        border-radius: 2px;
        background: linear-gradient(180deg, #2b5bff, #6e84ff);
      }

      .req {
        color: #ef4444;
      }
    }
  }

  // 金额选择
  .amount-list {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(130px, 1fr));
    gap: 14px;

    .amount-item {
      height: 52px;
      display: grid;
      place-items: center;
      border: 1.5px solid #e5e7eb;
      border-radius: 10px;
      font-size: 15px;
      font-weight: 500;
      color: #374151;
      cursor: pointer;
      transition: all 0.15s ease;

      &:hover {
        border-color: #c7d2fe;
        background: #fbfcff;
      }

      &.active {
        border-color: #2b5bff;
        background: linear-gradient(135deg, rgba(43, 91, 255, 0.08), rgba(110, 132, 255, 0.08));
        color: #2b5bff;
      }
    }
  }

  .custom-input-box {
    margin-top: 16px;

    .input-wrap {
      display: flex;
      align-items: center;
      background: #f8fafc;
      border: 1px solid #e5e7eb;
      border-radius: 10px;
      padding: 0 14px;
      transition: border-color 0.15s;

      &:focus-within {
        border-color: #2b5bff;
        box-shadow: 0 0 0 3px rgba(43, 91, 255, 0.12);
      }

      .prefix {
        font-size: 16px;
        color: #374151;
      }

      :deep(.el-input__wrapper) {
        background: transparent;
        box-shadow: none;
        padding-left: 8px;
      }

      :deep(.el-input__inner) {
        height: 44px;
        font-size: 14px;
      }
    }

    .tip-text {
      margin-top: 6px;
      font-size: 12px;
      color: #9ca3af;
    }
  }

  .error-text {
    margin-top: 6px;
    font-size: 12px;
    color: #ef4444;
  }

  // 支付方式
  .pay-list {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(160px, 1fr));
    gap: 14px;

    .pay-item {
      height: 64px;
      display: flex;
      align-items: center;
      gap: 10px;
      padding: 0 16px;
      border: 1.5px solid #e5e7eb;
      border-radius: 10px;
      cursor: pointer;
      transition: all 0.15s ease;

      &:hover {
        border-color: #c7d2fe;
        background: #fbfcff;
      }

      &.active {
        border-color: #2b5bff;
        background: linear-gradient(135deg, rgba(43, 91, 255, 0.08), rgba(110, 132, 255, 0.08));
      }

      .pay-icon {
        flex: 0 0 auto;
      }

      .pay-name {
        font-size: 14px;
        color: #374151;
      }
    }
  }

  // 对公转账面板
  .transfer-panel {
    margin-top: 16px;
    padding: 18px;
    background: #f5f8ff;
    border-radius: 10px;

    .panel-title {
      font-size: 14px;
      font-weight: 600;
      color: #111827;
      margin-bottom: 12px;
    }

    .transfer-row {
      display: flex;
      margin-bottom: 8px;
      font-size: 14px;

      .label {
        color: #6b7280;
        flex: 0 0 100px;
      }

      .value {
        color: #1f2937;
      }
    }

    .transfer-tip {
      margin-top: 12px;
      font-size: 12px;
      color: #de1c2c;
    }
  }

  .notice-block {
    padding: 12px 16px;
    background: #f5f8ff;
    border-radius: 10px;
    display: flex;
    align-items: center;
    gap: 8px;
    font-size: 12px;
    color: #4b5563;

    .dot {
      width: 6px;
      height: 6px;
      border-radius: 50%;
      background: #22c55e;
      box-shadow: 0 0 0 3px rgba(34, 197, 94, 0.18);
      flex-shrink: 0;
    }
  }

  .card-footer {
    padding: 24px 48px 36px;
    border-top: 1px dashed #eef0f5;

    .btn-primary {
      padding: 0 42px;
      height: 46px;
      background: linear-gradient(135deg, #2b5bff 0%, #4e6bff 100%);
      color: #fff;
      border: none;
      border-radius: 10px;
      font-size: 15px;
      font-weight: 500;
      box-shadow: 0 6px 18px -6px rgba(43, 91, 255, 0.55);

      &:hover {
        box-shadow: 0 10px 24px -6px rgba(43, 91, 255, 0.65);
        transform: translateY(-1px);
      }
    }
  }
}

@media (max-width: 640px) {
  .recharge-wrap {
    padding: 20px 12px;
  }

  .card-header,
  .card-body,
  .card-footer {
    padding-left: 20px;
    padding-right: 20px;
  }
}
</style>